import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="bg-gray-100 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700" data-id="element-134">
      <div className="max-w-6xl mx-auto px-4 py-8" data-id="element-135">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-136">
          <div data-id="element-137">
            <h3 className="font-bold text-lg mb-4 dark:text-white" data-id="element-138">
              JoinToday.co.ke
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-139">
              Educating & Connecting Kenyans through communities, events, and
              shared interests.
            </p>
            <div className="flex space-x-4" data-id="element-140">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 border border-gray-300 dark:border-gray-600 rounded-full flex items-center justify-center dark:text-gray-300 transition-transform duration-300 hover:scale-110 hover:bg-gray-200 dark:hover:bg-gray-700" data-id="element-141">
                <span className="text-sm" data-id="element-142">f</span>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 border border-gray-300 dark:border-gray-600 rounded-full flex items-center justify-center dark:text-gray-300 transition-transform duration-300 hover:scale-110 hover:bg-gray-200 dark:hover:bg-gray-700" data-id="element-143">
                <span className="text-sm" data-id="element-144">t</span>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 border border-gray-300 dark:border-gray-600 rounded-full flex items-center justify-center dark:text-gray-300 transition-transform duration-300 hover:scale-110 hover:bg-gray-200 dark:hover:bg-gray-700" data-id="element-145">
                <span className="text-sm" data-id="element-146">i</span>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 border border-gray-300 dark:border-gray-600 rounded-full flex items-center justify-center dark:text-gray-300 transition-transform duration-300 hover:scale-110 hover:bg-gray-200 dark:hover:bg-gray-700" data-id="element-147">
                <span className="text-sm" data-id="element-148">in</span>
              </a>
            </div>
          </div>
          <div data-id="element-149">
            <h4 className="font-bold mb-4 dark:text-white" data-id="element-150">Quick Links</h4>
            <ul className="space-y-2 text-sm" data-id="element-151">
              <li data-id="element-152">
                <Link to="/" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-153">
                  Home
                </Link>
              </li>
              <li data-id="element-154">
                <Link to="/communities" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-155">
                  Communities
                </Link>
              </li>
              <li data-id="element-156">
                <Link to="/events" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-157">
                  Events
                </Link>
              </li>
              <li data-id="element-158">
                <Link to="/jobs" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-159">
                  Jobs
                </Link>
              </li>
              <li data-id="element-160">
                <Link to="/movies" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-161">
                  Movies
                </Link>
              </li>
              <li data-id="element-162">
                <Link to="/tickets" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-163">
                  Tickets
                </Link>
              </li>
              <li data-id="element-164">
                <Link to="/deals-discounts" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-165">
                  Deals & Discounts
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-166">
            <h4 className="font-bold mb-4 dark:text-white" data-id="element-167">Resources</h4>
            <ul className="space-y-2 text-sm" data-id="element-168">
              <li data-id="element-169">
                <Link to="/help&FAQs" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-170">
                  Help Center & FAQs
                </Link>
              </li>
              <li data-id="element-171">
                <Link to="/blog" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-172">
                  Blog
                </Link>
              </li>
              <li data-id="element-173">
                <Link to="/contact" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-174">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-175">
                <Link to="/register" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-176">
                  Sell on JoinToday
                </Link>
              </li>
              <li data-id="element-177">
                <Link to="/partner" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-178">
                  Let's Partner
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-179">
            <h4 className="font-bold mb-4 dark:text-white" data-id="element-180">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-181">
              <li data-id="element-182">
                <Link to="/terms" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-183">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-184">
                <Link to="/privacy" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-185">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-186">
                <Link to="/refund" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-187">
                  Refund Policy
                </Link>
              </li>
              <li data-id="element-188">
                <Link to="/cookies" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-189">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-190">
                <Link to="/accessibility" className="hover:underline dark:text-gray-300 transition-colors duration-300 hover:text-gray-800 dark:hover:text-gray-100" data-id="element-191">
                  Accessibility
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 dark:border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-192">
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4 md:mb-0" data-id="element-193">
            &copy; {new Date().getFullYear()} JoinToday.co.ke. All rights
            reserved.
          </p>
          <div className="flex items-center" data-id="element-194">
            <div className="bg-gradient-to-r from-green-700 to-red-700 h-4 w-16 rounded mr-2" data-id="element-195"></div>
            <span className="text-xs text-gray-600 dark:text-gray-300" data-id="element-196">
              Proudly Kenyan
            </span>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;